module.exports = __webpack_public_path__ + "static/media/adults-eating-at-table.d75c652d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2019-10-18/adults-eating-at-table.jpg
// module id = 819
// module chunks = 0